// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3SuKv","requiredAsterisk":"Info_requiredAsterisk__POFeF"};